var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom"},[(_vm.component)?_c(_vm.component,{ref:"custom",tag:"custom",attrs:{"module":_vm.module},on:{"control":_vm.control}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }